import { faParagraph } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Dispatch, SetStateAction } from 'react';
import VoxelText from '../../../../../../components/voxel/Text/VoxelText';
import { ContentTaskGq } from '../../../../../../graphql/projects/models/ContentTaskGq';
import ContentTaskDetailInput from './ContentTaskDetailInput';

export interface ContentTaskMetaProps {
  contentTask: ContentTaskGq;
  reload: () => Promise<any>;
  updating?: boolean;
  setUpdating: Dispatch<SetStateAction<boolean>>;
}

const ContentTaskMeta: React.FC<ContentTaskMetaProps> = ({
  contentTask,
  reload,
  updating,
  setUpdating,
}) => {
  return (
    <div className={'w-72 h-full flex flex-col just gap-4 pb-12'}>
      <div className="flex flex-row items-center gap-2 mt-2">
        <FontAwesomeIcon icon={faParagraph} size="lg" />
        <VoxelText variant="title2">
          Meta
        </VoxelText>
      </div>
      <div className="h-full flex flex-col gap-16">
        <ContentTaskDetailInput
          label="Title"
          valueKey="titleNew"
          contentTask={contentTask}
          newValue={contentTask.titleNew}
          originalValue={contentTask.title}
          ruleValue={contentTask.titleRuleBased}
          reload={reload}
          updating={updating}
          setUpdating={setUpdating}
          maxLength={60}
          showCount
          showGenerated
          showManual
          areaSize="md"
        />
        <ContentTaskDetailInput
          label="H1"
          valueKey="h1New"
          contentTask={contentTask}
          newValue={contentTask.h1New}
          originalValue={contentTask.h1}
          ruleValue={contentTask.h1RuleBased}
          reload={reload}
          updating={updating}
          setUpdating={setUpdating}
          showCount
          showGenerated
          showManual
          areaSize="md"
        />
        <ContentTaskDetailInput
          label="Meta description"
          valueKey="metaNew"
          contentTask={contentTask}
          newValue={contentTask.metaNew}
          originalValue={contentTask.meta}
          ruleValue={contentTask.metaRuleBased}
          reload={reload}
          updating={updating}
          setUpdating={setUpdating}
          maxLength={160}
          showCount
          showGenerated
          showManual
          areaSize="full"
        />
      </div>
    </div>
  );
};

export default ContentTaskMeta;
